<template>
  <div id="app"
  > 
    <div v-if="!isMobile()">
      <router-view
        :galleries="galleries"
        >
      </router-view >
    </div>
    <div v-else>
      <div class="container m-0 p-0" style="background-color: black;">
        <div class="container mt-5 text-center" style="position: absolute; top:0;">
          <h1 style="font-size: 4vh;">Misalignments</h1>
        </div>
        <div class="container-fluid d-flex justify-content-center" style="height:100vh;">
          <div class="row align-self-center m-5">
            <h2 
              class="title-font text-center" 
              style="font-size:5vh;">Thank you for your visit! <br>Please view the exhibit on your desktop.</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import json from "@/assets/json/galleries.json"

export default {
  data: function() {
    return {
      galleries: json,
      pointerCursor: require('@/assets/cursors/magnify.svg'),
      thumbnail: require('@/assets/meta/thumbnail.jpg')
    }
  },
  metaInfo: {
  },
  methods: {
    isMobile() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
        }
      }
    },
    mounted: function() {
      // console.log(this.galleries);
    }
}
</script>

<style>
@font-face {
    font-family: 'Riposte Lazer';
    src: url("~@/fonts/Riposte-Lazer.eot");
    src: url("~@/fonts/Riposte-Lazer.eot?#iefix') format('embedded-opentype"),
        url("~@/fonts/Riposte-Lazer.woff2") format('woff2'),
        url("~@/fonts/Riposte-Lazer.woff") format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Riposte Thin';
    src: url("~@/fonts/Riposte-Thin.eot");
    src: url("~@/fonts/Riposte-Thin.eot?#iefix') format('embedded-opentype"),
        url("~@/fonts/Riposte-Thin.woff2") format('woff2'),
        url("~@/fonts/Riposte-Thin.woff") format('woff');
    font-weight: 100;
    font-style: normal;
    font-display: swap;
}

@font-face {
    font-family: 'Figue';
    src: url('~@/fonts/Figue-Regular.eot');
    src: url('~@/fonts/Figue-Regular.eot?#iefix') format('embedded-opentype'),
        url('~@/fonts/Figue-Regular.woff2') format('woff2'),
        url('~@/fonts/Figue-Regular.woff') format('woff'),
        url('fonts/Figue-Regular.ttf') format('truetype'),
        url('fonts/Figue-Regular.svg#Figue-Regular') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

/* Replace fonts with Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Inter+Tight:wght@300&family=Inter:wght@200&family=Playfair+Display&display=swap');

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  shape-rendering: smooth;
}

body {
  overflow-y: visible;
  cursor: url('~@/assets/cursors/magnify.svg'), auto;
  shape-rendering: smooth;
}

h1 {
  /* font-family: 'Figue', Avenir, Helvetica, Arial, sans-serif; */
  font-family: 'Inter Tight', sans-serif;
  font-size: 4vh;
}

.title-font {
  /* font-family: 'Riposte Lazer'; */
  font-family: 'Inter Tight', sans-serif;
  font-weight: 200;
  text-transform: uppercase;
  font-size: 3vh;
}

h2 {
  /* font-family: 'Riposte Lazer'; */
  font-family: 'Inter Tight', sans-serif;
  font-weight: 100;
  text-transform: uppercase;
  font-size: 3vh;
}

@media screen and (min-width: 601px) {
    .h2, h2 {
        font-size: 3vh;
    };
}

@media screen and (max-width: 601px) {
    .h2, h2 {
        font-size: 1.5rem;
    };
}

h4 {
  /* font-family: 'Riposte Lazer'; */
  font-family: 'Inter Tight', sans-serif;
  font-weight: 100;
  text-transform: uppercase;
  font-size: 2.5vh;
}

h5 {
  /* font-family: 'Figue'; */
  font-family: 'Inter Tight', sans-serif;
  font-size: 3vh;
}

.h6, h6 {
  /* font-family: 'Riposte Thin'; */
  font-family: 'Inter Tight', sans-serif;
  font-weight: 100;
  font-size: 1.5rem;
}

</style>
